import { overviewDashboardDataSource } from 'infrastructure/data-sources/overview-dashboard-interaction-time';
import BaseSelectBox from 'components/atoms/base-select-box';

import type { IOverviewDashboardInteractionTimeItem } from 'infrastructure/data-sources/overview-dashboard-interaction-time';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { FC } from 'react';

type Options = IBaseSelectBoxOption<
  IOverviewDashboardInteractionTimeItem['id'],
  IOverviewDashboardInteractionTimeItem
>[];

interface IInteractiveTimeSelectProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const dataSource = overviewDashboardDataSource();

const InteractiveTimeSelect: FC<IInteractiveTimeSelectProps> = (props) => {
  const options: Options = dataSource.map((item) => ({
    value: item.id,
    label: item.name,
    record: item,
  }));

  return <BaseSelectBox options={options} {...props} />;
};

export default InteractiveTimeSelect;
